// 버전 목록 패널 — 바닐라 dcf.js renderVersions/restoreVersion/deleteVersion 이식.
// 목록·복원·삭제 UI. 저장 시 자동 스냅샷 기록은 store.saveWithVersion 이 담당.
import { fmt } from "../../lib/format";
import { unitShare, useT } from "../../lib/i18n";
import { useDcf } from "../../stores/dcf";

export default function VersionsPanel() {
  const { lang, t } = useT();
  const versions = useDcf((s) => s.versions);
  const restoreVersion = useDcf((s) => s.restoreVersion);
  const deleteVersion = useDcf((s) => s.deleteVersion);

  if (!versions.length) {
    return (
      <div className="ver-list">
        <div className="ver-empty">{t("ver.empty")}</div>
      </div>
    );
  }

  return (
    <div className="ver-list">
      {versions.map((v) => {
        const pps = v.pps != null ? fmt(v.pps) + unitShare(lang) : "—";
        const w = v.wacc != null ? "WACC " + (v.wacc * 100).toFixed(1) + "%" : "";
        return (
          <div key={v.id} className="ver-row">
            <span className="ver-label">{v.label || t("ver.untitled")}</span>
            <span className="ver-meta">
              {v.createdAt || ""} · {pps}
              {w ? " · " + w : ""}
            </span>
            <button
              className="ver-btn"
              onClick={() => {
                if (
                  confirm(
                    "이 버전으로 현재 입력값을 되돌릴까요?\n\n" +
                      (v.label || "") +
                      "\n(현재 작업 중인 값은 덮어써집니다 — 필요하면 먼저 \"저장\")",
                  )
                )
                  void restoreVersion(v.id);
              }}
            >
              {t("ver.restore")}
            </button>
            <button
              className="ver-del"
              title={t("dash.del")}
              onClick={() => {
                if (confirm("이 버전을 삭제할까요?" + (v.label ? "\n\n" + v.label : "")))
                  deleteVersion(v.id);
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
